module.exports = __webpack_public_path__ + "static/media/plus.c43f8e45.svg";